<sbnb-loading-spinner minHeight="200px" *ngIf="(submitting$ | async) === true"></sbnb-loading-spinner>

<ng-container *ngIf="unsubmitted$ | async">
  <form class="flex flex-col" style="gap: 36px" [formGroup]="mutePropertiesForm">
    <h3>
      You must mute {{ propertiesEntitlement.disable }} {{ 'properties' | pluralize: propertiesEntitlement.disable }}
    </h3>
    <div class="scrollable-card">
      <div class="flex flex-wrap w-full justify-between items-center">
        <div class="text__large">Properties</div>
        <div class="flex justify-end" style="gap: 12px">
          <sbnb-button type="text-secondary" size="mini" (click)="properties.selectAll()">Select all</sbnb-button>
          <sbnb-button type="text-secondary" size="mini" (click)="properties.deselectAll()">
            Clear selection
          </sbnb-button>
        </div>
      </div>
      <mat-selection-list #properties formControlName="properties">
        <mat-list-option
          [checkboxPosition]="'before'"
          *ngFor="let property of propertiesEntitlement.data"
          [value]="property.id">
          <div class="flex items-center">
            <sbnb-mini-listing-img [imgSrc]="property.image_url"></sbnb-mini-listing-img>
            <span>{{ property.name }}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="flex flex-col" style="gap: 12px">
      <strong>What does this mean:</strong>
      <div style="margin-left: 24px">
        All Hospitable features, including calendar syncing and messaging, will stop immediately. Reservations at muted
        properties are not accessible in the inbox.
      </div>
    </div>
    <mat-divider></mat-divider>
    <div>
      <mat-checkbox style="padding: 0; align-items: start" formControlName="confirm" class="flex items-start">
        <strong>I confirm I understand the above and wish to mute</strong>
      </mat-checkbox>
    </div>
    <div class="flex justify-between">
      <button mat-flat-button class="button__secondary" [disabled]="submitting$ | async" (click)="cancel.emit()">
        Cancel
      </button>
      <div class="flex w-full justify-end" style="gap: 12px">
        <button mat-flat-button class="button__secondary" [disabled]="submitting$ | async" (click)="previous.emit()">
          Back
        </button>
        <button
          mat-flat-button
          class="button__primary"
          [disabled]="(submitting$ | async) || mutePropertiesForm.invalid"
          (click)="muteProperties()">
          Mute
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="success$ | async">
  <div class="flex flex-col items-center justify-center" style="gap: 24px; height: 200px; margin-bottom: 24px">
    <h3>Successfully muted</h3>
    <sbnb-icon icon="check" class="grass-darker" [size]="36"></sbnb-icon>
  </div>
</ng-container>

<ng-container *ngIf="error$ | async">
  <div class="flex flex-col items-center justify-center" style="gap: 24px; height: 200px; margin-bottom: 24px">
    <h3>An error occurred while trying to mute</h3>
    <img height="36" width="36" src="/assets/iconography/rejected.svg" />
  </div>
</ng-container>
